const API_VERSION = "2025-04";

export default API_VERSION;
